import DeathMusic from './death-music';

export function playDeathMusic(scene, onEnd) {
  if (!scene.deathMusic) scene.deathMusic = new DeathMusic();
  const midiFiles = {
    mel1: scene.cache.binary.get('death-mel1'),
    mel2: scene.cache.binary.get('death-mel2'),
    bass: scene.cache.binary.get('death-bass'),
  };
  if (!scene.deathMusic.initialized) {
    scene.deathMusic.init(midiFiles).then(() => scene.deathMusic.play(onEnd));
  } else {
    scene.deathMusic.play(onEnd);
  }
}

export function showGameOver(scene) {
  if (!document.getElementById('press-start-font')) {
    const link = document.createElement('link');
    link.id = 'press-start-font';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap';
    document.head.appendChild(link);
  }

  const el = document.createElement('div');
  el.id = 'game-over';
  el.style.cssText = `
    position: fixed;
    inset: 0;
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: 'Press Start 2P', monospace;
    z-index: 9999;
  `;
  el.innerHTML = `
    <div style="font-size:36px;letter-spacing:4px;">GAME OVER</div>
    <button id="game-over-restart" style="
      margin-top:48px;
      font-family:'Press Start 2P', monospace;
      font-size:14px;
      padding:14px 28px;
      background:black;
      color:white;
      border:none;
      cursor:pointer;
      letter-spacing:2px;
    ">TRY AGAIN</button>
  `;
  document.body.appendChild(el);
  document.getElementById('game-over-restart').onclick = () => {
    el.remove();
    scene.scene.restart({ lives: 4 });
  };
}
